export default __webpack_public_path__ + "static/media/feat_ld46.4dcb8759.jpg";